// Stripe Configuration
export const STRIPE_CONFIG = {
  publishableKey: `${process.env.REACT_APP_STRIPE_KEY}`,
  currency: 'usd',
  locale: 'en',
}

export const TEST_CARD_NUMBERS = {
  success: '4242424242424242',
  decline: '4000000000000002',
  insufficientFunds: '4000000000009995',
  expired: '4000000000000069',
  incorrectCvc: '4000000000000127',
  processingError: '4000000000000119',
} 